export const AI_COMING_SOON_TEXT = 'Sentrivox AI Assistant is under development and will be available soon.';
export const AI_COMING_SOON_FEATURES = ['AI chat assistant', 'Explain issue', 'Possible fix', 'AI issue notifications'];
export const AI_COMING_SOON_OPEN_EVENT = 'sentrivox:ai-coming-soon-open';

export const selectAiComingSoon = (s) => s.entitlements?.ai_coming_soon === true && s.entitlements?.ai_assistant !== true;
